function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.notificationA,.notificationB{fill:none;}\n.notificationB{stroke:current;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px;}\n.notificationC{fill:current;}\n.notificationD{fill:none;stroke:none}\n"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "notificationD",
  width: 24,
  height: 24
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 1)"
}, /*#__PURE__*/React.createElement("path", {
  className: "notificationB",
  d: "M17,10V7A7,7,0,0,0,3,7v3c0,3.3-3,4.1-3,6,0,1.7,3.9,3,10,3s10-1.3,10-3C20,14.1,17,13.3,17,10Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "notificationC",
  d: "M2.855.1C1.844.1.894.066,0,0A2.992,2.992,0,0,0,2.855,2.1,2.992,2.992,0,0,0,5.71,0C4.816.066,3.866.1,2.855.1Z",
  transform: "translate(7.145 20.9)"
}));

function SvgBellIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.534ea272.svg";
export { ForwardRef as ReactComponent };